import { usePageTitleTranslation } from 'libs/navigation';

import { useOnboardingSettings } from '../hooks/useOnboardingSettings';
import { OnboardingSettingsView } from '../views/OnboardingSettingsView';

export const OnboardingSettingsContainer = () => {
  const { initialValues, submitLoading, onSubmit } = useOnboardingSettings();

  usePageTitleTranslation('administration.title');

  return (
    <OnboardingSettingsView
      initialValues={initialValues}
      submitLoading={submitLoading}
      onSubmit={onSubmit}
    />
  );
};
